import { Routes } from '@angular/router';
import { ListeJuresComponent } from './pages/liste-jures/liste-jures.component';
import { UpdateJureComponent } from './pages/update-jure/update-jure.component';
import { AddEditQualificationComponent } from './modal/add-edit-qualification/add-edit-qualification.component';

export const JURES_ROUTE_DATA = {
    role: '(DECLARATION_TOURNEE_CONSULTER && ORGANISME) || ADMIN',
    domaines: ['VIN'],
    menu: {
        icon: 'users',
        libelle: 'menu.administration-jures'
    }
};

export const JURES_ROUTES: Routes = [
    { path: '', component: ListeJuresComponent },
    { path: 'jure/addJure', component: UpdateJureComponent },
    { path: 'jure/updateJure/:id', component: UpdateJureComponent },
    { path: 'add', redirectTo: 'new/edit' },
    { path: 'qualification/addQualification', component: AddEditQualificationComponent },
    { path: 'qualification/updateQualification/:id', component: AddEditQualificationComponent }
];
